'use client';

import { Box, } from '@mui/material';

import { MembershipTypeProps } from './MembershipType.interfaces';
import { useMembershipType } from './MembershipType.service';

import ItemCard from '@/common/components/ItemCard/ItemCard';
import StepTitle from '@/common/components/StepTitle/StepTitle';

import {
  styledStepContentCardsWrapper,
  styledItemCard,
} from '@/common/components/SalesFlow/StepsContent/StepsContent.styles';

export default function MembershipType({
  data,
  lang,
  step,
  analytics,
  excludedQueryKeys,
}: MembershipTypeProps) {
  const { selectedType, handleSelectType } = useMembershipType({
    data,
    lang,
    analytics,
    excludedQueryKeys,
  });
  if (!data?.length) return null;

  return (
    <>
      <StepTitle title={step?.stepTitle} subtitle={step?.stepSubtitle} />
      <Box sx={styledStepContentCardsWrapper}>
        {data.map((item, index) => {
          const itemTitle = item.title?.value;
          if (!itemTitle) return null;

          return (
            <ItemCard
              key={index}
              sx={styledItemCard}
              onClick={() => handleSelectType(itemTitle)}
              selected={itemTitle === selectedType}
              itemProps={{ __typename: 'MembershipType', ...item }}
              lang={lang}
            />
          );
        })}
      </Box>
    </>
  );
}
